import { FieldNames } from 'Constants/FieldNames'
import { BgRequestNav } from 'Pages/ibro'

export const beneficiaryCommercialFields = [FieldNames.CUSTOMERINN, FieldNames.CUSTOMERNAME]
export const guaranteeParamsFields = [FieldNames.STARTDATE, FieldNames.ENDDATE, FieldNames.AMOUNT]

export const beneficiaryFields = [
	FieldNames.CUSTOMERINN,
	FieldNames.CUSTOMERNAME,
	FieldNames.CUSTOMEROGRN,
	FieldNames.CUSTOMERKPP,
	FieldNames.CUSTOMERADDRESS,
	FieldNames.CUSTOMEREMAIL,
	FieldNames.CUSTOMERPHONE,
	FieldNames.CUSTOMEROKTMO,
]

export const purchaseFields = [
	FieldNames.PURCHNAME,
	FieldNames.PURCHURLISCHECK,
	FieldNames.SUPPORTDOC,
	FieldNames.PURCHASECODE,
	FieldNames.PURCHASEIDENTIFICATCODEIKZ,
	FieldNames.PURCHCODE,
	FieldNames.LOTNUMBER,
	FieldNames.LOTNAME,
	FieldNames.CONTRACTNUMBER,
	FieldNames.CONTRACTDATE,
	FieldNames.CONTRACTSUBJECT,
	FieldNames.SIGNEDCONTRACTFLAG,
	FieldNames.PURCHCUSTOMERNAME,
	FieldNames.PURCHCUSTOMERINN,
	FieldNames.PURCHCUSTOMERKPP,
	FieldNames.PUBLICATIONONDATETIME,
]

export const signedContractFlagFields = [
	FieldNames.CONTRACTNUMBER,
	FieldNames.CONTRACTDATE,
	FieldNames.CONTRACTSUBJECT,
	FieldNames.SUPPORTDOC,
]

export const REQUIRED_FIELDS_CREATE_BG_COMMERCIAL = [FieldNames.PRINCIPALINN]
export const REQUIRED_FIELDS_CREATE_BG_GOV = [
	...REQUIRED_FIELDS_CREATE_BG_COMMERCIAL,
	FieldNames.PURCHASECODE,
]

export const REQUIRED_FIELDS_CHECK_LIMIT = [
	FieldNames.STARTDATE,
	FieldNames.ENDDATE,
	FieldNames.AMOUNT,
]

export const accountSberBankFields = [
	FieldNames.FIRSTACCOUNT,
	FieldNames.SECONDACCOUNT,
	FieldNames.THIRDACCOUNT,
]
export const accountAnotherBankFields = [
	FieldNames.BIK,
	FieldNames.BANKNAME,
	FieldNames.CORRESPACCOUNT,
	FieldNames.CURENTACCOUNT,
]
export const bankRequisitesFields = [...accountSberBankFields, ...accountAnotherBankFields]

export const placerFields = [FieldNames.PLACERINN, FieldNames.PLACERNAME, FieldNames.PLACERADDRESS]

export const dependentTypeLegalAuthorityFields = [FieldNames.ORGADDRESS, FieldNames.NAMEPREPOST]
export const additionalLeaderFields = [
	FieldNames.TYPELEGALAUTHORITY,
	...dependentTypeLegalAuthorityFields,
]

export const dependentFlagSovetFields = [FieldNames.ISPRAVLENIETEXT]
export const dependentLicenseFields = [
	FieldNames.LICENSEVIEWNUMBER,
	FieldNames.LICENSEACTIVITY,
	FieldNames.LICENSEDATE,
	FieldNames.LICENSETERM,
	FieldNames.LICENSEWHOGIVE,
]
export const dependentPersonRezidFlagFields = [
	FieldNames.TAXCOUNTRY1,
	FieldNames.TAXIN1,
	FieldNames.TAXREASON1,
	FieldNames.TAXREASONTEXT1,
	FieldNames.TAXCOUNTRY2,
	FieldNames.TAXIN2,
	FieldNames.TAXREASON2,
	FieldNames.TAXREASONTEXT2,
	FieldNames.UI_TAXREASON1,
]

export const additionalClientFields = [
	FieldNames.PERSONREZIDFLAG,
	FieldNames.FACTS,
	FieldNames.FLAGSOVET,
	...dependentFlagSovetFields,
	FieldNames.FATCAFLAG,
	FieldNames.REPUTATION,
	FieldNames.ORGREZIDFLAG,
	FieldNames.BENEF,
	FieldNames.ISAGENTBENEF,
	...dependentPersonRezidFlagFields,
	FieldNames.FLAGLICENSE,
	...dependentLicenseFields,
]

export const documentsFields = [
	FieldNames.FINANCIALSTATEMENT,
	FieldNames.BIGDEALPROTOCOL,
	FieldNames.GENDIRSCAN,
	FieldNames.IPSCAN,
	FieldNames.USTAV,
	FieldNames.PROTOCOLGENDIRSCAN,
	FieldNames.BIGDEALAGREEMENT,
	FieldNames.DEBTLETTER,
	FieldNames.ANKETAFSC,
	FieldNames.EGRUL,
	FieldNames.OTHERDOCS,
]

export const leaderFields = [
	FieldNames.FIO,
	FieldNames.AUTHPOSITION,
	FieldNames.AUTHPERSONCITIZENSHIP,
	FieldNames.AUTHPERSONDATE,
	FieldNames.AUTHPERSONPLACE,
	FieldNames.AUTHADDRESS,
	FieldNames.AUTHPASSPORT,
	FieldNames.AUTHPASSPORTSER,
	FieldNames.AUTHPASSPORTNUM,
	FieldNames.AUTHPASSPORTDATEGIVE,
	FieldNames.AUTHPASSPORTKOD,
	FieldNames.AUTHPASSPORTWHOGIVE,
	FieldNames.AUTHINN,
]

export const leaderFieldsWithoutFIO = [
	FieldNames.AUTHPOSITION,
	FieldNames.AUTHPERSONCITIZENSHIP,
	FieldNames.AUTHPERSONDATE,
	FieldNames.AUTHPERSONPLACE,
	FieldNames.AUTHADDRESS,
	FieldNames.AUTHPASSPORT,
	FieldNames.AUTHPASSPORTSER,
	FieldNames.AUTHPASSPORTNUM,
	FieldNames.AUTHPASSPORTDATEGIVE,
	FieldNames.AUTHPASSPORTKOD,
	FieldNames.AUTHPASSPORTWHOGIVE,
	FieldNames.AUTHINN,
]

export const leaderDirectorFields = [
	FieldNames.FIO_DIRECTOR,
	FieldNames.AUTHINN_DIRECTOR,
	FieldNames.AUTHADDRESS_DIRECTOR,
	FieldNames.AUTHPASSPORT_DIRECTOR,
	FieldNames.AUTHPASSPORTSER_DIRECTOR,
	FieldNames.AUTHPASSPORTNUM_DIRECTOR,
	FieldNames.AUTHPASSPORTWHOGIVE_DIRECTOR,
	FieldNames.AUTHPASSPORTDATEGIVE_DIRECTOR,
	FieldNames.AUTHPASSPORTKOD_DIRECTOR,
	FieldNames.AUTHPERSONCITIZENSHIP_DIRECTOR,
	FieldNames.AUTHPERSONDATE_DIRECTOR,
	FieldNames.AUTHPERSONPLACE_DIRECTOR,
	FieldNames.AUTHPOSITION_DIRECTOR,
]

export const leaderDirectorFieldsWithoutFIO = [
	FieldNames.AUTHINN_DIRECTOR,
	FieldNames.AUTHADDRESS_DIRECTOR,
	FieldNames.AUTHPASSPORT_DIRECTOR,
	FieldNames.AUTHPASSPORTSER_DIRECTOR,
	FieldNames.AUTHPASSPORTNUM_DIRECTOR,
	FieldNames.AUTHPASSPORTWHOGIVE_DIRECTOR,
	FieldNames.AUTHPASSPORTDATEGIVE_DIRECTOR,
	FieldNames.AUTHPASSPORTKOD_DIRECTOR,
	FieldNames.AUTHPERSONCITIZENSHIP_DIRECTOR,
	FieldNames.AUTHPERSONDATE_DIRECTOR,
	FieldNames.AUTHPERSONPLACE_DIRECTOR,
	FieldNames.AUTHPOSITION_DIRECTOR,
]

export const flagpowerFields = [
	FieldNames.FLAG_POWER_OF_ATT_OR_NEY,
	FieldNames.NUMBER_POWER_OF_ATT_OR_NEY,
	FieldNames.DATE_POWER_OF_ATT_OR_NEY,
	FieldNames.POWER_OF_ATT_OR_NEY_JUR,
	FieldNames.AGREEMENT_DIRECTOR_SIGN,
	...leaderDirectorFields,
]

export const fieldsByFormBlock = {
	[BgRequestNav.GUARANTEE_BLANK]: [],
	[BgRequestNav.GUARANTEE_PROJECT]: [FieldNames.GUARANTEE_TEXT_TYPE, FieldNames.NEWGUARANTEEBLANK],
	[BgRequestNav.DOCUMENTS]: [...documentsFields],
	[BgRequestNav.ABOUT_BG]: [
		FieldNames.GUARANTEETYPE,
		FieldNames.REQUESTDATE,
		FieldNames.STARTDATE,
		FieldNames.ENDDATE,
		FieldNames.CONTRACTSTARTDATE,
		FieldNames.CONTRACTENDDATE,
		FieldNames.AMOUNT,
		FieldNames.INCREASED_AMOUNT,
		FieldNames.URL,
		FieldNames.PROTOTEXT,
		FieldNames.ARBITRAGE,
		FieldNames.PURCHASEIDENTIFICATCODEIKZ,
		FieldNames.AGREEWITHOUTIKZ,
		FieldNames.PURCHURLISCHECK,
		FieldNames.SUPPORTDOC,
		FieldNames.PLACINGWAYNAME,
		...beneficiaryFields,
		...purchaseFields,
	],
	[BgRequestNav.COST]: [
		FieldNames.COMMISSION,
		FieldNames.GUARANTEEMEDIUMTYPE,

		FieldNames.SENDADDRESS,
		FieldNames.PHONEFORDELIVERY,
		FieldNames.PERSONFORDELIVERY,
	],
	[BgRequestNav.CLIENT_INFO]: [
		...leaderFields,
		FieldNames.FULLNAME,
		FieldNames.OKVEDANOVER,
		FieldNames.EMAIL,
		FieldNames.PHONE,
		FieldNames.INN,
		FieldNames.KPP,
		FieldNames.OGRN,
		FieldNames.OGRNIP,
		FieldNames.OKATO,
		FieldNames.OKTMO,
		FieldNames.OKPO,
		FieldNames.ADDRESSJUR,
		FieldNames.ADDRESSFACT,
		FieldNames.REGISTRATIONADDRESS,
		FieldNames.REGISTRATIONDATE,
		FieldNames.REGISTRATIONTAXDATE,
		FieldNames.ISSTATENO,
		...bankRequisitesFields,
		...flagpowerFields,
		...additionalLeaderFields,
		...additionalClientFields,
	],
	[BgRequestNav.TAX_REPORT]: [
		FieldNames.TAXATIONSYSTEM,
		FieldNames.NONCURRENTASSETS,
		FieldNames.CURRENTASSETS,
		FieldNames.CAPITALRESERVES,
		FieldNames.DOH_BUD_PER,
		FieldNames.CURRENTLIAB,
		FieldNames.LONGTERMLIAB,
		FieldNames.REVEN,
		FieldNames.NETPROFIT,
		FieldNames.CURRENTASSETSLAST,
		FieldNames.CAPITALRESERVESLAST,
		FieldNames.CURRENTLIABLAST,
		FieldNames.NETPROFITLAST,
	],
}

export const unRequiredFields = [FieldNames.REPUTATION, FieldNames.PROTOTEXT, FieldNames.ARBITRAGE]

export const fieldsByNovaStatus = [
	FieldNames.CUSTOMERINN,
	FieldNames.CUSTOMERKPP,
	FieldNames.CUSTOMEROGRN,
	FieldNames.CUSTOMERNAME,
	FieldNames.CUSTOMEROKTMO,
	FieldNames.CUSTOMERADDRESS,
]
